export const getDevicePlatform = () => {
  const ua = navigator.userAgent || '';
  const isIOS = /iPhone|iPad|iPod/i.test(ua);
  const isAndroid = /android/i.test(ua);
  return { isIOS, isAndroid };
};

export const isDownloadAvailable = () => {
  return !!(process.env.REACT_APP_IOS_DOWNLOAD_URL && process.env.REACT_APP_ANDROID_DOWNLOAD_URL);
};

export const isAppPWA = () => {
  const isPWA =
    window.navigator.standalone === true ||
    window.matchMedia('(display-mode: standalone)').matches;

  return isPWA;
};

export const convertSecondsToTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  //retourner un code html
  return {
    minutes,
    seconds: remainingSeconds,
  };
};

export const convertSecondsToMilliseconds = (seconds) => {
   try {
    return seconds * 1000;
   } catch (error) {
    console.error(error, "error convertSecondsToMilliseconds default timeout return 30 seconds");
    return 30 * 1000;
   }
};

export function isEmptyObject(obj) {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}

export const formatJackpotAmount = (balance, isDecimal = false, defaultValue = '5') => {
  if (balance === undefined || balance === null) return defaultValue;
  return isDecimal ? Number(balance).toFixed(2).replace('.', ',') : balance.toString().replace('.', ',');
};

export const getJackpotDaysRemainingText = (daysRemaining, defaultDays = 7) => {
  const days = daysRemaining !== undefined ? daysRemaining : defaultDays;
  return days > 1 ? `${days} jours` : `${days} jour`;
};

export const getJackpotTargetAmount = (balance, defaultAmount = 5) => {
  return balance > 0 ? parseFloat(balance) : defaultAmount;
};

export const animateJackpotCounter = (targetAmount, setCount, timersRef) => {
  try {
    const maxInt = Math.floor(targetAmount);
    const length = Math.max(1, maxInt);

    Array.from({ length }, (_, i) => i + 1).forEach((val, i) => {
      const isLast = i === length - 1;
      const finalVal = isLast ? targetAmount : val;
      const tc = setTimeout(() => setCount(finalVal), (i + 1) * 240);
      if (timersRef && timersRef.current) {
        timersRef.current.push(tc);
      }
    });
  } catch (error) {
    console.error("Error in animateJackpotCounter:", error);
    setCount(targetAmount);
  }
};